/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ------------------------------------------------------------------
   "NEW" LABELS ON MENU ITEMS  (Boxaroo, added 6 Oct 2026)

   How to use it: in the Shopify admin, go to Content > Menus and add
   [New] to the end of a menu item's name, e.g.
       Inventory Overview [New]
   Remove [New] from the name to take the label off again.

   What this does: finds [New] inside menu links and buttons, removes
   it from the text, and adds the class "menu-item-new" to that link.
   The label itself is drawn by the CSS below (LABEL_CSS). It lives
   here, not in Theme settings > Custom CSS, because Shopify's Custom
   CSS does not allow the "content" property the label needs.

   It never adds an element inside a link: in Sept 2026 an extra
   element inside a dropdown link stopped Warehouse's menu closing.
   ------------------------------------------------------------------ */
(function () {
  var MARKER = /\s*\[new\]/gi;
  var LABEL_CLASS = 'menu-item-new';
  var STYLE_ID = 'menu-item-new-style';

  // The label's look. To change the colours, edit background and color.
  var LABEL_CSS = [
    '.menu-item-new::after {',
    '  content: "New";',
    '  display: inline-block;',
    '  flex: none;',
    '  align-self: center;',
    '  margin-left: 6px;',
    '  margin-right: auto;',
    '  padding: 2px 6px;',
    '  border-radius: 3px;',
    '  background: #e0f7fb;',
    '  color: #00788c;',
    '  font-size: 10px;',
    '  font-weight: 600;',
    '  line-height: 1.4;',
    '  letter-spacing: 0.06em;',
    '  text-transform: uppercase;',
    '  vertical-align: middle;',
    '  pointer-events: none;',
    '}'
  ].join('\n');

  function addLabelStyle() {
    if (document.getElementById(STYLE_ID)) return; // already added
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = LABEL_CSS;
    document.head.appendChild(style);
  }

  function hasMarker(text) {
    return /\[new\]/i.test(text);
  }

  function addNewLabels() {
    addLabelStyle();

    // 1. Find every piece of text containing [New]
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var found = [];
    while (walker.nextNode()) {
      if (hasMarker(walker.currentNode.nodeValue)) found.push(walker.currentNode);
    }

    // 2. For text inside a link or button: remove [New], add the class
    found.forEach(function (textNode) {
      var parent = textNode.parentElement;
      var item = parent ? parent.closest('a, button, summary') : null;
      if (!item) return; // not a menu link, so leave it alone
      textNode.nodeValue = textNode.nodeValue.replace(MARKER, '');
      item.classList.add(LABEL_CLASS);
    });

    // 3. Remove [New] from screen-reader labels and tooltips too
    var items = document.querySelectorAll('a, button, summary');
    for (var i = 0; i < items.length; i++) {
      ['aria-label', 'title'].forEach(function (name) {
        var value = items[i].getAttribute(name);
        if (value && hasMarker(value)) items[i].setAttribute(name, value.replace(MARKER, ''));
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addNewLabels);
  } else {
    addNewLabels();
  }
})();